import { PossibleEmployerContributionDto } from '@zorro/clients';
import { formatCurrencyEnUs } from '@zorro/shared/formatters';
import { Box, Flex, Text } from '@zorro/web/design-system';

type ChildBasedTooltipRowProps = {
  contribution: PossibleEmployerContributionDto;
};

export const ChildBasedTooltipRow = ({
  contribution,
}: ChildBasedTooltipRowProps) => {
  const numberOfChildren = contribution.numberOfDependents;
  const label = numberOfChildren ? `${numberOfChildren}` : '3+';
  const childText = numberOfChildren === 1 ? 'child' : 'children';

  return (
    <Flex
      key={contribution.numberOfDependents ?? 'multiple'}
      justify="space-between"
      gap="3rem"
    >
      <Flex gap="1rem" align="center">
        <Box w="0.5rem">
          <Text fz="xs">{label}</Text>
        </Box>
        <Text fz="xs">{childText}</Text>
      </Flex>
      <Text fz="xs">
        {formatCurrencyEnUs(contribution.stipend, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </Text>
    </Flex>
  );
};
